import React, { Component } from 'react';

import {
    Container,
    Row,
    Col,
    FormGroup, Label, Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';



import moment from 'moment';

import Isvg from 'react-inlinesvg';
import xIcon from '../../../assets/svg/x.svg';

import fullscreenIcon from '../../../assets/svg/fullscreen-icon.svg'


import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
} from 'chart.js';

import { Pie, Bar, Line, Chart } from 'react-chartjs-2';
import { GRAPH_COLORS } from './colorHelper';





ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController
);


class BarGraph extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,

        };
    }




    componentDidMount() {
        if (this.props.getGraphImage) {
            this.props.getGraphImage(this.getGraphImage)
        }

    }
    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {
        this.ref = null;
    }

    getGraphImage = () => {
        if (this.ref && this.ref?.toBase64Image?.()) {
            return this.ref.toBase64Image();
        }
    }



    render() {
        if (!this.props.data?.datasets?.length) {
            return null;
        }
        const backgroundColors = GRAPH_COLORS?.slice(0, this.props.data?.length);


        const options = {
            animation: {
                duration: 0
            },
            plugins: {
                title: {
                    display: false,
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                    },
                }
            },
            responsive: true,
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                },
            },
        };
        // const data = {
        //     labels: this.props.data?.map((item) => item.name) || [],
        //     datasets: [
        //         {
        //             label: '',
        //             data: this.props.data?.map((item) => item.value) || [],
        //             backgroundColor: backgroundColors,
        //             borderWidth: 0
        //         },
        //     ],
        // };
        const labels = this.props.data?.labels || [];

        const data = {
            labels,
            datasets: this.props.data.datasets?.map((item) => {
                let label = item.label;
                if (label === 'Unassigned') label = 'Unassigned'.translate(this.props.lang);
                return {
                    ...item,
                    label
                };
            }),
        };

        return (
            <div key={this.props.key} className="pie-graph-container">
                <Bar
                    ref={(node) => {
                        this.ref = node;

                    }}
                    options={options}
                    data={data}
                />


            </div>
        );


    }
}
export default BarGraph;